import PropTypes from "prop-types"
import React, { useEffect } from "react"
import { Route, Routes } from "react-router-dom"
import { connect, useDispatch } from "react-redux"

import "mdb-react-ui-kit/dist/css/mdb.min.css"
import "react-toastify/dist/ReactToastify.css"

// Routes
import { userRoutes, authRoutes } from "./routes/allRoutes"

// Layouts
import VerticalLayout from "./components/VerticalLayout/"
import HorizontalLayout from "./components/HorizontalLayout/"
import NonAuthLayout from "./components/NonAuthLayout"

// Middleware
import Authmiddleware from "./routes/middleware/Authmiddleware"

// Styles
import "./assets/scss/theme.scss"

// Toast
import { ToastContainer } from "react-toastify"

// Lock Context & Screen
import { LockProvider, useLock } from "./pages/AuthenticationInner/lockcontext"
import LockScreen from "./pages/AuthenticationInner/auth-lock-screen"



// Fake backend
import fakeBackend from "./helpers/AuthType/fakeBackend"
import Unauthorized from "pages/Unauthorized/Unauthorized"
fakeBackend()

// Main layout content with routes
const AppContent = ({ layout }) => {
  const Layout =
    layout.layoutType === "horizontal" ? HorizontalLayout : VerticalLayout
  const { isLocked, unlockScreen } = useLock()

  return (
    <>
      {/* auth route */}
      <Routes>
        {authRoutes.map((route, idx) => (
          <Route
            key={idx}
            path={route.path}
            element={<NonAuthLayout>{route.component}</NonAuthLayout>}
          />
        ))}

        {/* user route */}
        {userRoutes.map((route, idx) => (
          <Route
            key={idx}
            path={route.path}
            element={
              <Authmiddleware>
                <Layout>{route.component}</Layout>
              </Authmiddleware>
            }
          />
        ))}
        {/* custom unauthorised route */}

        <Route
          path="/unauthorized"
          element={
            <Layout>
              <Unauthorized />
            </Layout>
          }
        />
      </Routes>

      <LockScreen isOpen={isLocked} toggle={unlockScreen} />
      <ToastContainer position="top-right" autoClose={3000} />
    </>
  )
}

const App = props => {
  return (
    <LockProvider>
      <AppContent layout={props.layout} />
    </LockProvider>
  )
}

App.propTypes = {
  layout: PropTypes.any,
}

const mapStateToProps = state => ({
  layout: state.Layout,
})

export default connect(mapStateToProps)(App)
